import { xor, capitalize } from 'lodash';
import { getCompoundSentenceList } from '@format/list';
import { RECIPES_STANDARD_FORMAT, RECIPES_UPPERCASE_FORMAT } from './constants';

export const getPetDetailParams = petDetails =>
  new URLSearchParams({
    activity_level: petDetails?.activity ?? petDetails.activity_level,
    is_neutered: petDetails?.neutered ?? petDetails.is_neutered,
    weight: petDetails?.weight,
    ...(petDetails?.allergies && {
      allergies: petDetails.allergies?.join(',') ?? [],
    }),
  });

export const getMxPlanComboByRecipes = (planCombos, recipes) =>
  planCombos.find(
    planCombo =>
      !xor(planCombo?.recipes?.fresh, recipes?.fresh).length &&
      !xor(planCombo?.recipes?.baked, recipes?.baked).length,
  );

export const getNewPlan = (currentComboName, mealPlanRecommendations) => {
  if (!mealPlanRecommendations || !currentComboName) return undefined;
  const recommendedComboId = mealPlanRecommendations.recommended_combination_id;
  const recommendedCombo = mealPlanRecommendations.plan_combinations.find(
    plan => plan.combination_id === recommendedComboId,
  );

  return (
    mealPlanRecommendations.plan_combinations.find(
      plan => plan.name === currentComboName,
    ) || recommendedCombo
  );
};

export const formatMealPlanRecipes = (recipes = { baked: [], fresh: [] }) => {
  const { baked, fresh } = recipes;

  if (!baked.length && !fresh.length) {
    return '';
  }

  const formattedFresh = fresh.map(r => `Fresh ${capitalize(r)}`);
  const formattedDry = baked.map(r => `Baked ${capitalize(r)}`);

  return getCompoundSentenceList([...formattedFresh, ...formattedDry]);
};

export const getFreshRecipeFormat = (recipe, uppercase = false) => {
  const recipeFormat = uppercase
    ? RECIPES_UPPERCASE_FORMAT
    : RECIPES_STANDARD_FORMAT;
  return recipeFormat[recipe];
};
